export enum MLChannel {
  AOS = "aos", // Associate Order System
  APP = "app", // Mobile App
  CALIA = "calia",
  STACKD = "stackd",
  WEB = "web" // Website
}
